import React, { Component} from 'react';

import Select from '../Select';

const data = [
    {value: 1, label: "归档学期"},
    {value: 2, label: "归档年度"}
];

const TermYearStyle = (props) => (
    <Select name="isTerm" style={props.style || {width: 240}} label="学期/年度" data={data} {...props} ></Select>
);

export default TermYearStyle;